import NavBar from '@components/organisms/navbar/NavBar';
import { useAnalyticsUserProperties } from '@hooks/useAnalyticsUserProperties';
import { usePageView } from '@hooks/usePageView';
import { Outlet } from 'react-router';
import ModalWrapper from './ModalWrapper';

const RootLayout = () => {
    usePageView();
    useAnalyticsUserProperties();
    return (
        <ModalWrapper>
            <div className="flex flex-col w-full h-full min-h-[inherit] overflow-x-hidden">
                <NavBar />
                <div className="py-14 mx-auto w-full flex">
                    <Outlet />
                </div>
            </div>
        </ModalWrapper>
    );
};

export default RootLayout;
